module.exports = __webpack_public_path__ + "img/img_4662.ee8ae7cd.jpg";